<div
  class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent">
  <h2
    class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
    Explore the platform first
  </h2>
  <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">
    You can create a full brief anytime from the dashboard. When you are ready, continue to meet recommended
    creators for your brand.
  </p>

  <div class="mt-8 w-full max-w-md">
    <button type="button"
      class="w-full rounded-lg bg-primary px-4 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:hover:bg-primary/90"
      (click)="continueToRecommendedCreators()">
      Continue
    </button>
  </div>
</div>
